import {CollaboratorRole} from './CollaboratorRole';
import {Pagination} from './Pagination';
import {SortDirection} from './SortDirection';

/**
 * @export
 * @type WorkspaceRequest
 */
export type WorkspaceRequest = {
    /**
     * Name query to search workspaces by name (case insensitive, partial match)
     */
    nameQuery?: string;
    pagination: Pagination;
    sortDirection: SortDirection;
    /**
     * List of collaborator roles to filter workspaces by
     */
    ownerFilter: Array<CollaboratorRole>;
    sortBy: WorkspaceRequestSortBy;
}

export enum WorkspaceRequestSortBy {
    LAST_MODIFIED_DATE = 'LAST_MODIFIED_DATE',
    NAME = 'NAME',
    CREATED_DATE = 'CREATED_DATE'
}